import React from "react";
import When from "../../utils/When";
import AppConstants from "../../../constants/AppConstants";
import uiPrefix from "../../../utils/UiPrefixUtils";

const { TRANSPARENT } = AppConstants;

const PaletteItem = ({ paletteColor, index, onClick, selected }) => (
  <div
    title={paletteColor === TRANSPARENT ? "Transparent" : paletteColor}
    key={index}
    className="si-cp-palette-item"
    onClick={() => onClick(paletteColor, index)}
  >
    <div
      data-e2e={uiPrefix(`color-palette-swatch-${index + 1}-btn`)}
      className={`${uiPrefix(`color-palette-swatch-${index + 1}-btn`)} si-cp-palette-swatch ${
        paletteColor === TRANSPARENT ? "si-checkered-bg" : ""
      }`}
      style={{ backgroundColor: paletteColor }}
    >
      <When it={paletteColor !== TRANSPARENT}>
        <span className="si-c-colorpicker__swatch-number">{index + 1}</span>
      </When>
      <When it={selected}>
        <div className="si-cp-palette-item-selected">
          <span className="glyphicon glyphicon-circle_ok" />
        </div>
      </When>
    </div>
  </div>
);

const Palette = ({ paletteOptions, paletteIndex, onSelection }) => (
  <div className="si-cp-palette">
    {paletteOptions?.map((paletteColor, i) => (
      <PaletteItem
        paletteColor={paletteColor}
        key={`${paletteColor}-${i}`}
        index={i}
        selected={paletteIndex === i}
        onClick={onSelection}
      />
    ))}
  </div>
);

export default Palette;
